const appApplicationType = {
  id: "IAP",
  value: "IAP"
};

export default appApplicationType;
